module.exports = __webpack_public_path__ + "assets/img/Pioneer_Rochat_003.8bf33078-ps.jpg";